import styled from "@emotion/styled";

export const ActionRowWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;

  @media (min-width: 640px) {
    height: 3rem;
  }
`;

export const Wrapper = styled.div``;

export const InnerWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

export const InnerActionRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  padding: 0.75rem;
  padding-left: 0;

  @media (min-width: 640px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  button {
    width: 100%;
  }
`;

export const ActionButton = styled.button`
  border: none;
  background: none;
  color: #2f8de4;
  font-weight: 600;
  font-size: 12px;
  font-family: Poppins, sans-serif;
  i {
    margin-right: 2.5px;
    font-size: 16px;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FullscreenButton = styled.button`
  border: none;
  background: none;
  padding: 0px;
  font-size: 20px;
  color: #2f8de4;
  margin-left: 10px;
`;
